import { AxiosResponse } from 'axios'
import { api } from '../../api'

export const sendBordero = async (eventId: string) => {
  const { status }: AxiosResponse = await api.post(
    `/api/backoffice/events/${eventId}/bordero`
  )

  return status
}
